export const isDev = (): boolean => {
  const devDomains = ['tdgrid.snimg1.com', 'td.snimg1.com', 'localhost', 'td-makeup.snimg1.com'];
  return devDomains.includes(window.location.hostname);
};
